import _objectSpread from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
var _excluded = ["applicationName", "beaconEndpoint", "debug", "deploymentEnvironment", "instrumentations", "recordAll", "sampleRatio"];
import SplunkRum from '@splunk/otel-web';
import { propagation } from '@opentelemetry/api';
import TracingBase from './TracingBase';
import TracingPropagator from './TracingPropagator';
import CustomSampler from './CustomSampler';
import { ALLOWED_CORS_DOMAINS, ALLOWED_EVENTS, BOX_DOMAIN_NAMES, getEnvironment, serialize } from './utils';

var TracingSplunk = /*#__PURE__*/function (_TracingBase) {
  _inherits(TracingSplunk, _TracingBase);

  var _super = _createSuper(TracingSplunk);

  function TracingSplunk(config) {
    var _this;

    _classCallCheck(this, TracingSplunk);

    _this = _super.call(this, config);

    _this.init();

    return _this;
  }

  _createClass(TracingSplunk, [{
    key: "init",
    value: function init() {
      var _SplunkRum$provider, _SplunkRum$provider$r;

      var _this$options = this.options,
          applicationName = _this$options.applicationName,
          beaconEndpoint = _this$options.beaconEndpoint,
          debug = _this$options.debug,
          deploymentEnvironment = _this$options.deploymentEnvironment,
          instrumentations = _this$options.instrumentations,
          recordAll = _this$options.recordAll,
          sampleRatio = _this$options.sampleRatio,
          options = _objectWithoutProperties(_this$options, _excluded);

      if (!debug && !beaconEndpoint) {
        throw new Error('Unable to initialize tracing without beaconEndpoint');
      }

      var _window$location = window.location,
          hostname = _window$location.hostname,
          href = _window$location.href; // Scope cookie to root domain when on known Box domain, otherwise set to undefined which will scope cookie to current domain

      var cookieDomain = BOX_DOMAIN_NAMES.find(function (boxDomainName) {
        return hostname === boxDomainName || hostname.endsWith(".".concat(boxDomainName));
      });
      SplunkRum.init(_objectSpread({
        applicationName: applicationName,
        // Converts relative url to absolute url to bypass issue with RUM treating all relative urls as unsafe
        beaconEndpoint: beaconEndpoint && new URL(beaconEndpoint, href).href,
        context: {
          // Patches async browser APIs (setTimeout, RAF, Promise, etc.) to retain active span context
          async: false
        },
        cookieDomain: cookieDomain,
        debug: debug,
        // Exports all spans to the console and allows absent or insecure beacon url
        deploymentEnvironment: getEnvironment(deploymentEnvironment),
        exporter: {
          onAttributesSerializing: serialize
        },
        instrumentations: _objectSpread({
          fetch: {
            propagateTraceHeaderCorsUrls: ALLOWED_CORS_DOMAINS
          },
          interactions: {
            eventNames: ALLOWED_EVENTS
          },
          longtask: false,
          // Experimental API that seems relatively low-value
          socketio: false,
          // Not currently used in any frontend applications
          xhr: {
            propagateTraceHeaderCorsUrls: ALLOWED_CORS_DOMAINS
          }
        }, instrumentations),
        tracer: {
          sampler: new CustomSampler({
            debug: debug,
            recordAll: recordAll,
            sampleRatio: sampleRatio !== null && sampleRatio !== void 0 ? sampleRatio : 0
          })
        }
      }, options));
      propagation.disable();
      propagation.setGlobalPropagator(new TracingPropagator());

      if ((_SplunkRum$provider = SplunkRum.provider) !== null && _SplunkRum$provider !== void 0 && (_SplunkRum$provider$r = _SplunkRum$provider.resource) !== null && _SplunkRum$provider$r !== void 0 && _SplunkRum$provider$r.attributes) {
        SplunkRum.provider.resource.attributes['service.name'] = 'browser';
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      SplunkRum.deinit();
    }
  }, {
    key: "setGlobalAttributes",
    value: function setGlobalAttributes() {
      var attributes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      SplunkRum.setGlobalAttributes(_objectSpread(_objectSpread({}, SplunkRum.getGlobalAttributes()), attributes));
    }
  }, {
    key: "traceError",
    value: function traceError(name) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      SplunkRum.error.apply(SplunkRum, [name].concat(args));
    }
  }]);

  return TracingSplunk;
}(TracingBase);

export { TracingSplunk as default };